import { render, staticRenderFns } from "./DetailGeneralInfoPanel.vue?vue&type=template&id=6f777685&"
import script from "./DetailGeneralInfoPanel.vue?vue&type=script&lang=js&"
export * from "./DetailGeneralInfoPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports